export default __webpack_public_path__ + "static/media/warning--trucks-rollover--g2.a08fc624.png";